import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * Fallback UI shown while lazy-loaded route components are loading.
 */
function PageLoading() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="50vh"
    >
      <CircularProgress />
    </Box>
  );
}

export default PageLoading;
